import { PageComponent } from "barba";

class Header {
    constructor({ node }) {
        this.header = node;
        this.body = document.querySelector("body");
        this.overlay = node.querySelector(".header__overlay");
        this.button = node.querySelector(".header-button");
        this.banner = node.querySelector(".header-banner");
        this.menu = node.querySelector(".nav-mobile");
        this.subNavRegistry = [];
        this.windowWidth = window.innerWidth;

        this.toggleMenuHandler = this.toggleMenu.bind(this);
        this.overlayClickHandler = this.overlayClick.bind(this);
        this.bannerAnimationEndHandler = this.bannerAnimationEnd.bind(this);
        this.resizeHandler = this.resize.bind(this);

        for (let subNav of node.querySelectorAll("[data-has-subnav]")) {
            this.subNavRegistry.push(new HeaderSubNav(this, subNav));
        }

        this.button.addEventListener("click", this.toggleMenuHandler);
        this.overlay.addEventListener("click", this.overlayClickHandler);
        this.banner.addEventListener("animationend", this.bannerAnimationEndHandler);
        window.addEventListener("resize", this.resizeHandler);
        window.addEventListener("scroll", this.scrollHandler);
    }

    closeAllSubNav() {
        this.subNavRegistry.forEach((x) => x.close());
    }

    resize() {
        if (this.windowWidth === window.innerWidth) {
            return;
        }
        this.windowWidth = window.innerWidth;
        this.closeAllSubNav();
        this.closeMenu();
        this.hideOverlay();
    }

    toggleMenu() {
        if (this.isMenuOpen()) {
            this.closeMenu();
            return;
        }
        this.openMenu();
    }

    openMenu() {
        if (!this.isMobile()) {
            return;
        }

        this.body.classList.add("overflow-hidden", "h-screen");

        this.header.style.setProperty("--header-offset-y", "0px");

        this.button.classList.add("header-button--open");
        this.menu.classList.add("nav-mobile--open");

        this.button.title = this.button.dataset.labelClose;
    }

    closeMenu() {
        if (!this.isMobile()) {
            return;
        }

        this.body.classList.remove("overflow-hidden", "h-screen");

        this.button.classList.remove("header-button--open");
        this.menu.classList.remove("nav-mobile--open");

        this.button.title = this.button.dataset.labelMenu;
    }

    isMenuOpen() {
        return this.menu.classList.contains("nav-mobile--open");
    }

    overlayClick() {
        this.isDesktop() ? this.closeAllSubNav() : null;
    }

    showOverlay() {
        this.overlay.classList.add("header__overlay--show");
    }

    hideOverlay() {
        this.overlay.classList.remove("header__overlay--show");
    }

    isMobile() {
        return !this.isDesktop();
    }

    isDesktop() {
        return window.matchMedia("(min-width: 992px)").matches;
    }

    bannerAnimationEnd() {
        this.banner.classList.remove("header-banner--translate-y");
    }

    destroy() {
        this.subNavRegistry.forEach((x) => x.destroy());

        this.body.classList.remove("overflow-hidden", "h-screen");
        this.button.removeEventListener("click", this.buttonClickHandler);
        this.overlay.removeEventListener("click", this.overlayClickHandler);
        this.banner.removeEventListener("animationend", this.bannerAnimationEndHandler);
        window.removeEventListener("resize", this.resizeHandler);

        delete this.header;
        delete this.overlay;
        delete this.button;
        delete this.banner;
        delete this.menu;
        delete this.subNavRegistry;
        delete this.windowWidth;

        delete this.buttonClickHandler;
        delete this.overlayClickHandler;
        delete this.bannerAnimationEndHandler;
        delete this.resizeHandler;
    }
}

class HeaderSubNav {
    constructor(header, subNav) {
        this.header = header;
        this.subNav = subNav;
        this.html = document.querySelector("html");
        this.body = document.querySelector("body");
        this.navItem = this.subNav.querySelector("[data-subnav]");
        this.navLink = this.subNav.querySelector("[data-subnav-open]");

        this.clickOutsideHandler = this.clickOutside.bind(this);
        this.toggleHandler = this.toggle.bind(this);
        this.openHandler = this.open.bind(this);
        this.closeHandler = this.close.bind(this);

        this.html.addEventListener("click", this.clickOutsideHandler);
        this.navLink.addEventListener("click", this.toggleHandler);
        this.navItem.addEventListener("focusin", this.openHandler);
        this.navItem.addEventListener("focusout", this.closeHandler);
    }

    clickOutside(e) {
        if (!this.navItem.contains(e.target) && this.header.isDesktop()) {
            this.close();
        }
    }

    toggle(e) {
        if (this.subNav.classList.contains("nav-desktop__main-item--open")) {
            this.close();
            return;
        }
        this.open();
        // Prevent execution of "clickOutside" method
        e.stopPropagation();
    }

    open() {
        if (this.header.isDesktop()) {
            this.header.closeAllSubNav();
            this.header.showOverlay();
        }
        this.body.classList.add("overflow-hidden", "h-screen");
        this.subNav.classList.add("nav-desktop__main-item--open");
        this.navLink.classList.add("nav-item-first-level--open");
    }

    close() {
        if (this.header.isDesktop()) {
            this.header.hideOverlay();
        }
        this.body.classList.remove("overflow-hidden", "h-screen");
        this.subNav.classList.remove("nav-desktop__main-item--open");
        this.navLink.classList.remove("nav-item-first-level--open");
    }

    destroy() {
        this.body.classList.remove("overflow-hidden", "h-screen");
        this.html.removeEventListener("click", this.clickOutsideHandler);
        this.navLink.removeEventListener("click", this.toggleHandler);
        this.navItem.removeEventListener("focusin", this.openHandler);
        this.navItem.removeEventListener("focusout", this.closeHandler);

        delete this.clickOutsideHandler;
        delete this.toggleHandler;
        delete this.openHandler;
        delete this.closeHandler;

        delete this.header;
        delete this.subNav;
        delete this.html;
        delete this.navItem;
        delete this.navLink;
    }
}

new PageComponent(".header", Header);
